"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardInfo = CardInfo;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CardInfo(_ref) {
  let {
    children,
    text,
    onClick,
    icon,
    color,
    className
  } = _ref;
  const props = {
    color,
    paddingBottom: text ? '12px' : '24px',
    className
  };
  const classes = (0, _styles.default)(props)();
  const handleClick = () => {
    onClick();
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.CardContext
  }, /*#__PURE__*/_react.default.createElement("main", {
    className: classes.CardMain
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.CardDetails
  }, children)), text && /*#__PURE__*/_react.default.createElement("footer", {
    className: classes.CardFooter
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.CardInteractive,
    onClick: handleClick,
    onKeyDown: handleClick
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.CardText
  }, text)), icon)));
}
CardInfo.propTypes = {
  children: _propTypes.default.element.isRequired,
  text: _propTypes.default.string,
  onClick: _propTypes.default.func,
  icon: _propTypes.default.element,
  color: _propTypes.default.string,
  className: _propTypes.default.objectOf(_propTypes.default.any)
};
CardInfo.defaultProps = {
  text: null,
  onClick: () => {},
  icon: null,
  color: null,
  className: null
};